import TopicForm from './TopicForm.jsx';
import { Modal } from '../Modals/Modal.jsx';

export const EditModal = ({ open, setOpen, item, setItem }) => {
  const onClose = () => {
    setOpen(false);
    setItem(null);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <TopicForm item={item} closeModal={onClose} />
    </Modal>
  );
};
